import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from 'api/axios';
import { baseTableFilter, buildQueryString } from 'utils/general';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
};

export const getConfigVariables = createAsyncThunk('configVars/getConfigVariables', async (filter, { rejectWithValue }) => {
	try {
		const queryData = buildQueryString({
			search: filter.search,
			type: filter.type,
			startDate: filter.startDate,
			endDate: filter.endDate,
			isActive: filter.isActive?.toString(),
		});

		console.log(queryData, 'queryData...lang');

		const response = await axiosInstance.get(
			`/config-variables?sortBy=${filter?.sortBy ?? baseTableFilter.sortBy}&page=${filter?.page ?? baseTableFilter.page ?? 1}&limit=${filter?.limit ?? baseTableFilter.limit}${queryData ? '&' + queryData : ''}`,
		);

		if (response.success) {
			return response;
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		console.log(err, 'err...lang');

		return rejectWithValue(err.message || 'Error');
	}
});

export const configVarsSlice = createSlice({
	name: 'configVars',
	initialState,
	reducers: {
		showLoading: (state) => {
			state.loading = true;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getConfigVariables.pending, (state) => {
				state.loading = true;
			})
			.addCase(getConfigVariables.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getConfigVariables.rejected, (state, action) => {
				state.message = action.payload;
				state.showMessage = true;
				state.loading = false;
			});
	},
});

export const { showLoading, setLanguages } = configVarsSlice.actions;

export default configVarsSlice.reducer;
